import { useAuthStore } from '../../../stores/authStore';
import { useSettings } from '../../../hooks/useSettings';
import { ComplianceRules } from '../../../components/settings/ComplianceRules';
import { SettingsSubPage } from '../components/SettingsSubPage';
import { Skeleton } from '../../../components/common/Skeleton';
import { palette, admin } from '../../../styles/tokens';

export function TaxCompliancePage() {
  const authBusiness = useAuthStore(s => s.business);
  const { business, loading, error, saved, updateBusinessRules, updateBusiness } = useSettings(authBusiness?.id);

  if (loading || (!business && !error)) {
    return (
      <SettingsSubPage title="Tax & compliance" description="HST rates, CRA categories, mileage rates">
        <div style={{ background: palette.white, borderRadius: admin.cardRadius, border: `1px solid ${admin.border}`, padding: 20 }}>
          <Skeleton width={160} height={14} style={{ marginBottom: 14 }} />
          <Skeleton width="70%" height={13} style={{ marginBottom: 8 }} />
          <Skeleton width="55%" height={13} style={{ marginBottom: 16 }} />
          <Skeleton width={120} height={36} radius={8} style={{ marginBottom: 16 }} />
          <Skeleton width="100%" height={1} style={{ marginBottom: 16, background: palette.g100 }} />
          <Skeleton width={140} height={13} style={{ marginBottom: 8 }} />
          <Skeleton width={200} height={32} radius={6} />
        </div>
      </SettingsSubPage>
    );
  }

  if (error || !business) {
    return (
      <SettingsSubPage title="Tax & compliance" description="HST rates, CRA categories, mileage rates">
        <div style={{ padding: 40, textAlign: 'center', color: palette.red, fontSize: 13.5 }}>{error ?? 'Not found'}</div>
      </SettingsSubPage>
    );
  }

  return (
    <SettingsSubPage title="Tax & compliance" description="HST rates, CRA categories, mileage rates">
      {saved && (
        <div style={{
          position: 'fixed', top: 68, right: 36, zIndex: 100,
          padding: '10px 20px', borderRadius: 8,
          background: palette.greenWash, border: `1px solid ${palette.green}`,
          color: palette.green, fontSize: 13, fontWeight: 500,
        }}>
          Saved
        </div>
      )}
      <ComplianceRules business={business} onSaveRules={updateBusinessRules} onSaveBusiness={updateBusiness} />
    </SettingsSubPage>
  );
}
